/***********************
 * NODE CHART
 * (+ IMPORT PDF/XLSX)
 ************************/

import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"
import "assets/scss/custom/charts/custom-chart.css"

//Translation
import { withTranslation } from "react-i18next"
import { initLanguage, localesApexChart } from "common/languagesApexCharts"
import {
  basicGrid,
  nodeChartOptions,
  //   nodeChartHistoryOptions,
} from "./nodeChartOptions"

const NodeChart = props => {
  const [language, setLanguage] = useState("fi")
  //   Options
  const [chartOptions, setChartOptions] = useState(nodeChartOptions.default)

  useEffect(() => {
    if (props.dataType === "temperature") {
      setChartOptions(nodeChartOptions.temperature)
    }
    if (props.dataType === "humidity") {
      setChartOptions(nodeChartOptions.humidity)
    }
    //not in use yet/ if (props.dataType === "lineActivityHistory") {
    //   console.log(nodeChartHistoryOptions.historyActivityLine)
    //   setChartOptions(nodeChartHistoryOptions.historyActivityLine)
    // }
    // if (props.dataType === "columnActivityHistory") {
    //   setChartOptions(nodeChartHistoryOptions.historyActivityColumn)
    // }
    // if (props.dataType === "areaActivityHistory") {
    //   setChartOptions(nodeChartHistoryOptions.historyActivityArea)
    // }
  }, [props.dataType])

  // Init language
  useEffect(() => {
    // console.log("NODECHART PROPS", props)
    setLanguage(initLanguage)
  }, [])

  const series = [
    {
      name: props.t(chartOptions.title),
      type: props.type,
      data: props.data,
    },
  ]
  const options = {
    chart: {
      id: props.chartId,
      locales: localesApexChart,
      defaultLocale: language,
      stacked: false,
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: chartOptions.tools,
        export: {
          csv: {
            filename: props.t(chartOptions.title),
            columnDelimiter: " ",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString()
            },
          },
          svg: {
            filename: props.t(chartOptions.title),
          },
          png: {
            filename: props.t(chartOptions.title),
          },
        },
        autoSelected: "zoom",
      },
      dropShadow: chartOptions.dropShadow ? chartOptions.dropShadow : {},
    },
    stroke: chartOptions.stroke,
    dataLabels: {
      enabled: false,
    },
    colors: chartOptions.colors,
    fill: chartOptions.fill,
    markers: {
      size: 0,
    },
    legend: {
      offsetY: 11,
    },
    xaxis: chartOptions.xaxis,
    yaxis: chartOptions.yaxis,
    grid: basicGrid,
    plotOptions: chartOptions.plotOptions ? chartOptions.plotOptions : {},
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (y !== undefined && y != 0 && y != 0) {
            return (
              y.toFixed(0) +
              " " +
              (props.yTooltip ? props.yTooltip : props.t(chartOptions.form))
            )
          }
          return y
        },
      },
      x: chartOptions.tooltipX,
    },
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      type={props.type ? props.type : "area"}
      height={props.height ? props.height : "300"}
    />
  )
}

NodeChart.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  chartId: PropTypes.any,
  type: PropTypes.any,
  dataType: PropTypes.any,
  height: PropTypes.any,
  yTooltip: PropTypes.any,
  //   optionsColumn: PropTypes.any,
}

export default withTranslation()(NodeChart)
